define('models/pages/requests/index',['require','underscore','chaplin','models/base/model','models/base/collection','lib/utils','./table'],function(require) {
    'use strict';

    var _ = require('underscore'),
        Chaplin = require('chaplin'),
        Model = require('models/base/model'),
        Collection = require('models/base/collection'),
        utils = require('lib/utils'),
        TableModel = require('./table');

    var RequestsPageModel = Model.extend({
        defaults: {
        },
        constructor: function(data) {
            Model.apply(this, arguments);

            this.items = new TableModel();
        },
        load: function() {
            var items = this.items;

            if (this.get('archive')) {
                items.fromDate = utils.fmtDate(this.get('fromDate'));
                items.toDate = utils.fmtDate(this.get('toDate'));
            }
            return items.fetch();
        }
    });


    return RequestsPageModel;
});
